import { ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ProfessionalInfoCardProps {
	imageUrl: string;
	title: string;
	description?: string;
	onClick: () => void;
	isSelected: boolean;
	disabled?: boolean;
	/** data-testid for e2e (ex.: agendamento público) */
	dataTestId?: string;
}

const ProfessionalInfoCard = ({
	imageUrl,
	title,
	description,
	onClick,
	isSelected,
	disabled = false,
	dataTestId,
}: ProfessionalInfoCardProps) => {
	return (
		<button
			type="button"
			data-testid={dataTestId}
			onClick={!disabled ? onClick : undefined}
			disabled={disabled}
			aria-pressed={isSelected}
			className={cn(
				'group relative flex w-full min-w-0 items-center gap-5 rounded-[28px] border-2 bg-white p-5 pr-12 text-left',
				isSelected
					? 'border-black shadow-lg ring-1 ring-black'
					: 'border-transparent shadow-sm',
				disabled && 'cursor-not-allowed opacity-50 grayscale',
				!disabled && 'cursor-pointer',
			)}
		>
			<div className="flex h-14 w-14 flex-shrink-0 items-center justify-center overflow-hidden rounded-2xl border border-gray-100 bg-gray-50 p-1.5">
				<img
					src={imageUrl}
					alt=""
					className="h-full w-full object-contain"
					loading="lazy"
					decoding="async"
				/>
			</div>

			<div className="min-w-0 flex-1 text-left">
				<h3 className="text-[17px] font-bold leading-tight text-gray-900">
					{title}
				</h3>
				{description ? (
					<p className="truncate text-[10px] font-bold leading-relaxed text-gray-400">
						{description}
					</p>
				) : null}
			</div>

			{isSelected ? (
				<span
					aria-hidden
					className="pointer-events-none absolute right-6 top-1/2 h-2.5 w-2.5 -translate-y-1/2 rounded-full bg-black shadow-sm"
				/>
			) : (
				<ChevronRight
					size={16}
					className="pointer-events-none absolute right-6 top-1/2 -translate-y-1/2 text-gray-500 transition-transform duration-200 group-hover:translate-x-1"
					aria-hidden
					strokeWidth={2}
				/>
			)}
		</button>
	);
};
export { ProfessionalInfoCard };
